import { createSlice, PayloadAction } from "@logicsoftware/redux-toolkit";
import { AiCompletionState } from "../types";

const slice = createSlice({
    name: "AiCompletionSlice",
    initialState: null,
    reducers: {
        setAiCompletion: (_, action: PayloadAction<AiCompletionState>) => action.payload,
        setAiSuggestion: (state, action: PayloadAction<string>) => ({ ...state, suggestion: action.payload }),
    },
});

export const { setAiCompletion, setAiSuggestion } = slice.actions;
export const aiCompletionReducer = slice.reducer;
